import { Alert, AppSvg, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import React from 'react'
import s from './style.module.css'
import { lang } from './lang'

interface Props {
    onClick: () => void
    transactionCount: number
}

function Approve({ onClick, transactionCount }: Props) {
    return (
        <div className={s.wrap}>
            <Alert
                icon={<AppSvg svgName={newIcons.ic16Alert} size={16} path="new-icons" />}
                dataPointer="approve_alert"
                className={s.alertWrap}
                text={
                    <div className={s.content}>
                        <FormattedHTMLMessage {...lang.title} values={{ transactionCount }} />
                        <span className={s.showAll} onClick={onClick}>
                            <FormattedHTMLMessage {...lang.showAll} />
                            <AppSvg svgName={newIcons.ic16ChevronDown} size={16} path="new-icons" className={s.arrow} />
                        </span>
                    </div>
                }
                type="warning"
            />
        </div>
    )
}

export default Approve
